export default "__VITE_ASSET__d72d54c1__"